import ApiCalls from "../../config/apiCalls";
import Location from "../../config/location";
import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";
import {
  projectBasePathWithFolder,
  redirectToMapScreenAfterSeconds,
} from "../../config/apiEndpoints";
import { keyMapsAction, keyMapsMutation } from "../../helpers/storeKeys";
import { ORDER_TYPE } from "../../helpers/OrderStatusConstants";
import {
  EVENT_IMPRESSION_NO_RESTAURANT_AVAILABLE,
  EVENT_IMPRESSION_NO_DELIVERY_ZONE,
} from "../../helpers/analyticsEvents";

const storeNotFound = function (commit) {
  if (
    !Utility.checkWindowLocationIncludes(
      Utility.getCurrentStoreFolder() + Location.defaultStoreId
    )
  ) {
    LocalStorageFunc.unsetSessionStorageKey("noDeliveryLocation");
    // window.location.href =
    //   projectBasePathWithFolder +
    //   Utility.getCurrentStoreFolder() +
    //   // Location.defaultStoreId +
    //   Utility.getUrlQueryString();
  }
  commit("updateStoreNotFound", {});
};

const afterStoreApiSuccess = function (stores, commit, dispatch) {
  if (
    !Utility.checkWindowLocationIncludes(
      Utility.getCurrentStoreFolder() + stores.id
    ) &&
    !Utility.isNoRedirectTrue() &&
    !Utility.isCurrentlyAtUrl("/location")
  ) {
    commit("updateIsLocationSettled", {});
    setTimeout(() => {
      window.location.href =
        projectBasePathWithFolder +
        Utility.getCurrentStoreFolder() +
        stores.id +
        Utility.getUrlQueryString();
    }, 2000);
    return;
  } else {
    commit("updateIsLocationSettled", {});
  }

  /* stores.data.data.online = 0;
  stores.data.data.startTime = "16:00"; */
  commit("updateStoreDetails", stores);
  if (LocalStorageFunc.getDeliveryType() == "D") {
    commit("updateHomePageAddress", stores);
  }
  commit("updateNearestApiTopAddress", stores.city);
  if (!stores.online) {
    dispatch("Location/locatorStoreTakeawayDineInAvailabilityApi", {});
  }

  // dispatch(keyMapsAction.WELCOME_OFFER_API, {}, { root: true });
  // dispatch(keyMapsAction.PIZZA_TOPPING_API, {}, { root: true });
};

const updateLocalLocationAfterStoreApi = function (stores, commit, payload) {
  LocalStorageFunc.updateStoreId(stores.id);
  let delType = localStorage?.selectedDeliveryType?.length
    ? localStorage?.selectedDeliveryType
    : LocalStorageFunc.getDeliveryType();
  let locationData = {
    latitude: stores.addressComponent?.latitude || stores.latitude,
    longitude: stores.addressComponent?.longitude || stores.longitude,
    addressRequired: true,
  };
  if (payload.deliveryAddressId) {
    locationData.address_id = payload.deliveryAddressId;
  }
  commit("updateLocationFromGeoCodeApiCombo", {
    address_alias: Utility.getAddressAlias(stores),
    complete_address:
      delType != "D"
        ? stores?.name || ""
        : stores?.homePageAddress?.bottomAddress ||
          stores?.displayAddress ||
          "",
    lastLocationObjectforLocalStorage: {
      recent: stores,
      location: locationData,
      deliveryType:
        localStorage.selectedDeliveryType || LocalStorageFunc.getDeliveryType(),
      source: payload.source,
    },
    isTrueLocationDetected: payload.source == "ip" ? false : true,
  });
};

const updateLocalLocationBasedOnGeodataAndStoreData = function (
  stores,
  userlocation,
  commit,
  payload
) {
  LocalStorageFunc.updateStoreId(stores.id);
  let delType = localStorage?.selectedDeliveryType?.length
    ? localStorage?.selectedDeliveryType
    : LocalStorageFunc.getDeliveryType();
  let locationData = {
    latitude:
      userlocation?.location?.latitude ||
      stores.addressComponent?.latitude ||
      stores.latitude,
    longitude:
      userlocation?.location?.longitude ||
      stores.addressComponent?.longitude ||
      stores.longitude,
    addressRequired: true,
  };
  if (payload.deliveryAddressId) {
    locationData.address_id = payload.deliveryAddressId;
  }
  commit("updateLocationFromGeoCodeApiCombo", {
    address_alias: Utility.getAddressAlias(stores),
    complete_address:
      delType != "D"
        ? stores?.name || ""
        : stores?.homePageAddress?.bottomAddress ||
          stores?.displayAddress ||
          "",
    lastLocationObjectforLocalStorage: {
      recent: stores,
      location: locationData,
      deliveryType:
        localStorage.selectedDeliveryType || LocalStorageFunc.getDeliveryType(),
      source: payload.source,
    },
    isTrueLocationDetected: payload.source == "ip" ? false : true,
  });
};
export default {
  namespaced: true,
  state: {
    isTrueLocationDetected: false,
    isTakeAwaySelected: false,
    locationData: LocalStorageFunc.getComputedLocationData()
      ? LocalStorageFunc.getComputedLocationData()
      : false,
    isHomePageAddressAvailable: false,
    storeStartTime: "00:00",
    takeawayStoreList: [],
    geoCodeInitialValue: {
      prediction: {
        type: Object,
        default: {},
      },
      geoCode: {
        type: Object,
        default: {},
      },
    },
    focusedStore: 0,
    selectedStoreId: "",
    takeawayDineAvailability: {
      TAKEAWAY: false,
      DINEIN: false,
    },
    childStoreId: "",
    storeNotFound: false,
    currentLocationUnservicable: false,
    noDeliveryZoneData: {},
    isLocationSettled: false,
    storeDetails: {
      online: 1,
    },
    showLocationAccessBlockedModal: false,
    showDeliveryMapScreen: false,
    showManualLocationScreen: LocalStorageFunc.getShowManualLocationScreen(),
    currentLocation: {},
    autoCompleteInput: "",
    autoCompletePredictions: [],
    googleAddressComponent: [],
    showLocationLoading: false,
    noInternet: false,
    nearestApiTopAddress: Utility.isStoreUrlCacheEligible()
      ? LocalStorageFunc.nearestApiTopAddress()
      : "",
    selectedChangedLocationForTwyDinein: LocalStorageFunc.getSelectedChangedLocationForTwyDinein()
  },
  getters: {},
  mutations: {
    updateLocationFromGeoCodeApiCombo(state, payload) {
      state.isTrueLocationDetected = payload.isTrueLocationDetected;
      let delType = localStorage?.selectedDeliveryType?.length
        ? localStorage?.selectedDeliveryType
        : LocalStorageFunc.getDeliveryType();
      LocalStorageFunc.setIsTrueLocationDetected(
        payload.isTrueLocationDetected
      );
      if (!state.isHomePageAddressAvailable && delType == "D") {
        state.locationData = {
          address_alias: payload.address_alias,
          complete_address: payload.complete_address,
        };
        LocalStorageFunc.setComputedLocationData(state.locationData);
      }
      LocalStorageFunc.updateLastLocation(
        payload.lastLocationObjectforLocalStorage
      );
    },
    updateIsTakeAwaySelected(state, payload) {
      state.isTakeAwaySelected = payload;
    },
    updateGeoCodeInitialValue(state, payload) {
      state.geoCodeInitialValue = payload;
    },
    updateLocationFromLocalStorage(state, payload) {
      state.isTrueLocationDetected = payload.isTrueLocationDetected;
      LocalStorageFunc.setIsTrueLocationDetected(
        payload.isTrueLocationDetected
      );
      state.locationData = payload.data;
      LocalStorageFunc.setComputedLocationData(payload.data);
    },
    resetLocationState(state, payload) {
      state.isTrueLocationDetected = false;
      LocalStorageFunc.unsetSessionStorageKey("isTrueLocationDetected");
      state.locationData = {};
      LocalStorageFunc.setComputedLocationData({});
      state.isLocationSettled = true;
      state.isHomePageAddressAvailable = false;
    },
    updateTakeAwayStoresList(state, payload) {
      if (payload?.length == 0) {
        EVENT_IMPRESSION_NO_RESTAURANT_AVAILABLE();
      }
      state.takeawayStoreList = payload;
    },
    updateNoInternet(state, payload) {
      state.noInternet = payload;
    },
    updateStoreNotFound(state, payload) {
      state.storeNotFound = true;
      state.isLocationSettled = true;
    },
    updateTakeawayDineAvailability(state, payload) {
      state.takeawayDineAvailability.TAKEAWAY = payload.TAKEAWAY || false;
      state.takeawayDineAvailability.DINEIN = payload.DINEIN || false;
    },
    updateCurrentLocationUnservicable(state, payload) {
      state.currentLocationUnservicable = payload;
    },
    updateNoDeliveryZoneData(state, payload) {
      state.noDeliveryZoneData = payload;
    },
    updateIsLocationSettled(state, payload) {
      state.isLocationSettled = true;
      LocalStorageFunc.setIsStoreIdCacheEligible();
    },
    resetIsLocationSettled(state, payload) {
      state.isLocationSettled = false;
      LocalStorageFunc.unsetSessionStorageKey("isStoreIdCacheEligible");
    },
    updateStoreDetails(state, payload) {
      if (payload.startTime) {
        let hour = +payload.startTime.split(":")[0] || 0;
        let minute = +payload.startTime.split(":")[1];
        payload.startTime = {
          hour: hour > 12 ? hour - 12 : hour,
          minute: minute,
          amOrPm: hour > 12 ? "pm" : "am",
          advanceOrderApplicable:
            new Date().getHours() < hour ||
            (new Date().getHours() == hour && new Date().getMinutes() < minute),
        };
      } else {
        payload.startTime = {
          advanceOrderApplicable: false,
        };
      }
      state.storeDetails = payload;
    },
    updateShowLocationAccessBlockedModal(state, payload) {
      state.showLocationAccessBlockedModal = payload;
    },
    updateHomePageAddress(state, payload) {
      if (payload.homePageAddress) {
        state.locationData = {
          address_alias: Utility.getAddressAlias(payload),
          complete_address:
            LocalStorageFunc.getDeliveryType() != "D"
              ? payload?.name || ""
              : payload.homePageAddress.bottomAddress,
        };
        state.isHomePageAddressAvailable = true;
        LocalStorageFunc.setComputedLocationData(state.locationData);
      }
    },
    updateNearestApiTopAddress(state, payload) {
      state.nearestApiTopAddress = payload;
      LocalStorageFunc.setNearestApiTopAddress(payload);
    },
    updateShowDeliveryMapScreen(state, payload) {
      state.showDeliveryMapScreen = payload;
    },
    updateShowManualLocationScreen(state, payload) {
      LocalStorageFunc.setShowManualLocationScreen(payload);
      state.showManualLocationScreen = payload;
    },
    updateGeoCode(state, payload) {
      state.geoCode = payload;
    },
    updateChildStoreId(state, payload) {
      state.childStoreId = payload;
    },
    updateCurrentLocation(state, payload) {
      state.currentLocation = payload;
    },
    updateAutoCompleteData(state, payload) {
      state.autoCompleteInput = payload.input;
      state.autoCompletePredictions = payload.predictions;
    },
    clearAutoCompleteInput(state) {
      state.autoCompleteInput = "";
      state.autoCompletePredictions = [];
    },
    updateFocusedStore(state, payload) {
      state.focusedStore = payload;
    },
    updateSelectedStore(state, payload) {
      state.selectedStoreId = payload;
    },
    updateGoogleAddressComponent(state, payload) {
      state.googleAddressComponent = payload;
    },
    updateShowLocationLoading(state, payload) {
      state.showLocationLoading = payload;
    },
    updateTakeAwayOrDineInStoreOnSelection(state, payload) {
      let lastLocationObjectforLocalStorage = {
        recent: payload,
        location: {
          latitude: payload.addressComponent?.latitude || payload.latitude,
          longitude: payload.addressComponent?.longitude || payload.longitude,
          addressRequired: true,
        },
        deliveryType:
          payload?.stations[0]?.deliveryTypeCode ||
          localStorage.selectedDeliveryType ||
          LocalStorageFunc.getDeliveryType(),
      };
      LocalStorageFunc.updateLastLocation(lastLocationObjectforLocalStorage);
      state.locationData = {
        address_alias: Utility.getAddressAlias(),
        complete_address: payload.name,
      };
      LocalStorageFunc.setComputedLocationData(state.locationData);
    },
  },
  actions: {
    geoCodeApi({ commit, dispatch }, payload) {
      return ApiCalls.GEOCODE_API({
        headers: Headers(),
        payload,
      });
    },
    detectCurrentLocation({ commit, dispatch }, payload) {
      let pos = {};
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            if (
              payload.triggerEditAddress &&
              payload.setLocationOfEditAddress
            ) {
              pos.lat = payload?.lat || pos.lat;
              pos.lng = payload?.lng || pos.lng;
              // console.log("inside edit address location",pos?.lat)
              // console.log("inside edit address location",pos?.lng)
            }
            commit("updateCurrentLocation", pos);

            if (payload.showDeliveryMapScreen) {
              commit("updateShowDeliveryMapScreen", true);
            }
            if (payload.setGeoCode) {
              dispatch("geoCodeApiCombo", position).then(() => {
                commit("updateShowLocationLoading", false);
              });
            }
            if (payload.triggerTakeAway) {
              dispatch("locatorStoreTakeawayApi", {
                setStoreByDefault: payload.setStoreByDefault,
              });
            }
            if (payload.triggerDineIn) {
              dispatch("locatorStoreTakeawayApi", {
                orderType: ORDER_TYPE.DINEIN,
                setStoreByDefault: payload.setStoreByDefault,
              });
            }
          },
          () => {
            // fallback if location permissions not given
            if (payload.showDeliveryMapScreen) {
              commit("updateShowDeliveryMapScreen", true);
            }
            if (
              payload.triggerEditAddress &&
              payload.setLocationOfEditAddress
            ) {
              pos.lat = payload?.lat || pos.lat;
              pos.lng = payload?.lng || pos.lng;
              commit("updateCurrentLocation", pos);
              // console.log("inside edit address location",pos?.lat)
              // console.log("inside edit address location",pos?.lng)
            } else if (
              LocalStorageFunc.getCoordsFromRecentLocation()?.coords
                ?.latitude &&
              !payload.currentLocationDisplay
            ) {
              if (payload.triggerTakeAway) {
                dispatch("locatorStoreTakeawayApi", {
                  setStoreByDefault: payload.setStoreByDefault,
                });
              }
              if (payload.triggerDineIn) {
                dispatch("locatorStoreTakeawayApi", {
                  orderType: ORDER_TYPE.DINEIN,
                  setStoreByDefault: payload.setStoreByDefault,
                });
              }
              if (!payload.triggerTakeAway && !payload.triggerDineIn) {
                dispatch("googleGeoLocationApi", { ...payload }).then(() => {
                  commit("updateShowLocationLoading", false);
                });
              }
            } else {
              dispatch("googleGeoLocationApi", { ...payload }).then(() => {
                commit("updateShowLocationLoading", false);
              });
            }
          }
        );
      } else {
        dispatch(keyMapsAction.GOOGLE_GEO_LOCATION_API, {});
        if (payload.showDeliveryMapScreen) {
          commit("updateShowDeliveryMapScreen", true);
        }
        if (payload.triggerEditAddress && payload.setLocationOfEditAddress) {
          pos.lat = payload?.lat || pos.lat;
          pos.lng = payload?.lng || pos.lng;
          commit("updateCurrentLocation", pos);
          // console.log("inside edit address location",pos?.lat)
          // console.log("inside edit address location",pos?.lng)
        }
      }
    },
    saveCurrentGPSLocation({ commit, dispatch }) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          ApiCalls.GEOCODE_API({
            headers: Headers(),
            payload: {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            },
          })
            .then(function (response) {
              if (response.data.status === "SUCCESS") {
                LocalStorageFunc.setCurrentGPSLocation(
                  response.data?.results && response.data?.results[0]
                );
              }
            })
            .catch(function (err) {});
        });
      }
    },
    detectGeoLocationPopup({ commit, dispatch }, payload) {
      if (
        payload.source == "locationPopupBanner" ||
        !LocalStorageFunc.isStoreUrlCacheEligible()
      ) {
        commit("updateIsLocationSettled", {});
        LocalStorageFunc.unsetSessionStorageKey("isStoreIdCacheEligible");
      }
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (data) => {
            LocalStorageFunc.setIsLocationPermissionGiven();
            dispatch("geoCodeApiCombo", data);
          },
          (error) => {
            LocalStorageFunc.unsetKey("isLocationPermissionGiven");
            LocalStorageFunc.setAskLocationLaterInSession();
            if (
              payload.source == "locationPopup" ||
              payload.source == "locationPopupBanner"
            ) {
              payload.showModalM();
            } else {
              dispatch("googleGeoLocationApi", error);
            }
          },
          Location.geoLocationOptions
        );
      } else {
        commit("resetLocationState", {});
      }
    },
    googleGeoLocationApi({ commit, dispatch }, payload) {
      ApiCalls.GOOGLE_GEOLOCATION_API({
        headers: {},
        payload: {
          considerIp: true,
        },
      })
        .then(function (response) {
          if (response?.data?.location?.lat) {
            commit("updateCurrentLocation", {
              lat: response.data.location.lat,
              lng: response.data.location.lng,
            });
            dispatch("nearestStoreApi", {
              coords: {
                latitude: response.data.location.lat,
                longitude: response.data.location.lng,
              },
              source: "ip",
            });
          } else {
            if (
              response.message == "Network Error" ||
              response.message == "Request failed with status code 404"
            ) {
              commit("updateNoInternet", true);
            }
            dispatch("loadRecentLocationFromLocalStorage");
          }
        })
        .then(() => {
          if (payload.showDeliveryMapScreen) {
            commit("updateShowDeliveryMapScreen", true);
          }
          if (payload.triggerEditAddress && payload.setLocationOfEditAddress) {
            pos.lat = payload?.lat || pos.lat;
            pos.lng = payload?.lng || pos.lng;
            commit("updateCurrentLocation", pos);
            // console.log("inside edit address location",pos?.lat)
            // console.log("inside edit address location",pos?.lng)
          }
        })
        .catch(function (error) {
          dispatch("loadRecentLocationFromLocalStorage");
        });
    },

    storeDetailsApi({ commit, dispatch }, payload) {
      ApiCalls.STORE_DETAILS_API({
        headers: { ...Headers() },
        payload: payload,
      })
        .then(function (response) {
          if (response?.data) {
            commit("updateSelectedStore", response.data.id);
            LocalStorageFunc.setSessionStorageKey(
              "takeawayLocation",
              response.data
            );
          } else {
          }
        })
        .catch(function (error) {});
    },

    cachedStoreApi({ commit, dispatch }, payload) {
      Promise.all([
        ApiCalls.STORE_DETAILS_API({
          headers: { ...Headers(), getstoreloyaltyprogramcode: true },
          payload: {
            storeId: payload.storeId,
          },
        }),
      ])
        .then(async ([stores]) => {
          if (stores?.data?.data?.id) {
            const lastLocation = Utility.tryJsonParse(
              localStorage.lastLocationNew
            );
            if (lastLocation && lastLocation[0]?.recent?.homePageAddress) {
              stores.data.data.homePageAddress =
                lastLocation[0].recent.homePageAddress;
            }
            commit("updateStoreDetails", stores.data.data);
            commit("updateHomePageAddress", stores.data.data);
            commit("updateIsLocationSettled", {});
            commit("updateNearestApiTopAddress", stores.data.data.city);
            updateLocalLocationAfterStoreApi(stores.data.data, commit, payload);
            if (!stores.data.data.online) {
              dispatch(
                "Location/locatorStoreTakeawayDineInAvailabilityApi",
                {}
              );
            }
          }
        })
        .catch((errors) => {});
    },

    updateCachedStoreData({ commit, dispatch }, payload) {
      const recentLastLocation = Utility.tryJsonParse(
        localStorage.lastLocationNew
      )[0]?.recent;
      if (
        payload.storeId === recentLastLocation?.id &&
        !Utility.isPageReloaded()
      ) {
        commit("updateStoreDetails", recentLastLocation);
        commit("updateHomePageAddress", recentLastLocation);
        commit("updateIsLocationSettled", {});
        commit("updateNearestApiTopAddress", recentLastLocation.city);
        updateLocalLocationAfterStoreApi(recentLastLocation, commit, payload);
        if (!recentLastLocation.online) {
          dispatch("Location/locatorStoreTakeawayDineInAvailabilityApi", {});
        }
      } else {
        // dispatch("cachedStoreApi", payload);
      }
    },
    nearestStoreApi({ commit, dispatch }, payload) {
      let delType = localStorage.userInfo
        ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.deliveryType ||
          "D"
        : "D";
      Promise.all([
        ApiCalls.NEAREST_STORE_API({
          headers: { ...Headers() },
          payload: {
            latitude: payload.coords.latitude,
            longitude: payload.coords.longitude,
            addressRequired: true,
          },
        }),
      ])
        .then(async ([stores]) => {
          commit("updateShowLocationLoading", false);
          if (stores?.data?.data?.id) {
            payload.source = "ip";
            updateLocalLocationAfterStoreApi(
              stores?.data?.data,
              commit,
              payload
            );
            afterStoreApiSuccess(stores?.data?.data, commit, dispatch);
            commit("updateNearestApiTopAddress", stores.data.data.city);

            let { addressComponent = {} } = stores?.data?.data || {};
            const userlocation = {
              location: {
                latitude:
                  payload.coords.latitude || addressComponent?.latitude || "",
                longitude:
                  payload.coords.longitude || addressComponent?.longitude || "",
              },
            };

            if (delType === "D") {
              LocalStorageFunc.setLocalStorageValue(
                "userLocationData",
                JSON.stringify(userlocation)
              );
            }
          } else {
            if (delType === "D") {
              LocalStorageFunc.setLocalStorageValue("userLocationData", "");
            }
            storeNotFound(commit);
          }
        })
        .catch((errors) => {
          if (delType === "D") {
            LocalStorageFunc.setLocalStorageValue("userLocationData", "");
          }
          dispatch("loadRecentLocationFromLocalStorage");
        });
    },

    geoCodeApiCombo({ commit, dispatch, rootGetters, state }, payload) {
      let showDeliveryMapScreen = payload.showDeliveryMapScreen || false;
      let redirectTo = payload.redirectTo || (() => {});
      let delType = localStorage?.selectedDeliveryType?.length
        ? localStorage?.selectedDeliveryType
        : localStorage.userInfo
        ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.deliveryType ||
          "D"
        : "D";
      let payload1 = payload?.coords
        ? {
            latitude: payload?.coords?.latitude,
            longitude: payload?.coords?.longitude,
            addressRequired: true,
          }
        : {
            placeId: payload.place_id,
          };
      Promise.all([
        ApiCalls.LOCATOR_STORES_V3_API({
          headers: { ...Headers() },
          payload: payload1,
        }),
      ])
        .then(async ([response]) => {
          // if (LocalStorageFunc.getSessionStorageKey("takeawayLocation")) {
          //   return;
          // }
          commit("updateGeoCodeInitialValue", {
            prediction: {},
            geoCode: {
              name: response?.data?.geoCodeData?.formattedAddress,
              displayAddress: response?.data?.geoCodeData?.displayAddress,
              footerAddress: response?.data?.geoCodeData?.footerAddress,
            },
          });
          commit("updateGoogleAddressComponent", response?.data?.geoCodeData);
          commit("updateShowLocationLoading", false);
          let noDeliveryZoneD = {
            location: {
              latitude: response?.data?.geoCodeData?.geometry?.location?.lat,
              longitude: response?.data?.geoCodeData?.geometry?.location?.lng,
            },
            displayText:
              (response?.data?.geoCodeData &&
                response?.data?.geoCodeData?.displayAddress) ||
              "",
          };
          if (!response?.data?.storeData?.id) {
            commit("updateNoDeliveryZoneData", noDeliveryZoneD);
            EVENT_IMPRESSION_NO_DELIVERY_ZONE({
              subCategory: noDeliveryZoneD.displayText,
            });
          } else {
            commit("updateNoDeliveryZoneData", {});
          }

          let { addressComponent = {} } = response?.data?.storeData || {};
          let userlocation = {
            location: {
              latitude:
                response?.data?.geoCodeData?.geometry?.location?.lat ||
                addressComponent?.latitude ||
                "",
              longitude:
                response?.data?.geoCodeData?.geometry?.location?.lng ||
                addressComponent?.longitude ||
                "",
            },
          };

          commit("updateCurrentLocation", {
            lat: userlocation?.location?.latitude,
            lng: userlocation?.location?.longitude,
          });
          if (!response.data.storeData) {
            dispatch("locatorStoreTakeawayApi", {
              latitude: userlocation?.location?.latitude,
              longitude: userlocation?.location?.longitude,
            });
            if (showDeliveryMapScreen) {
              commit("updateShowDeliveryMapScreen", true);
            }
            redirectTo();
            return;
          }
          if (response?.data?.storeData?.id) {
            if (
              payload.source == "ip" &&
              LocalStorageFunc.storeId() == Location.defaultStoreId
            ) {
              LocalStorageFunc.setHideLocationPopupOnceInSession();
            }
            updateLocalLocationBasedOnGeodataAndStoreData(
              response.data.storeData,
              userlocation,
              commit,
              payload
            );
            // updateLocalLocationAfterStoreApi(
            //     response.data.storeData,
            //     commit,
            //     payload
            //   );
            afterStoreApiSuccess(response.data.storeData, commit, dispatch);
            if (showDeliveryMapScreen) {
              commit("updateShowDeliveryMapScreen", true);
            }
            if (delType === "D") {
              LocalStorageFunc.setLocalStorageValue(
                "userLocationData",
                JSON.stringify(userlocation)
              );
            }
            redirectTo();
          } else if (
            LocalStorageFunc.storeId() == Location.defaultStoreId
            // && !LocalStorageFunc.getReturnedFromMapScreen()
          ) {
            LocalStorageFunc.setNoDeliveryZoneInSession(noDeliveryZoneD);
            // LocalStorageFunc.setReturnedFromMapScreen();
            if (delType === "D") {
              LocalStorageFunc.setLocalStorageValue(
                "userLocationData",
                JSON.stringify(userlocation)
              );
            }
            if (showDeliveryMapScreen) {
              commit("updateShowDeliveryMapScreen", true);
            }
            redirectTo();
            return;
          } else {
            let payload2 = LocalStorageFunc.getCoordsFromRecentLocation();
            if (payload2) {
              await ApiCalls.LOCATOR_STORES_V3_API({
                headers: Headers(),
                payload: {
                  latitude: payload2.coords.latitude,
                  longitude: payload2.coords.longitude,
                },
              })
                .then(async function (response) {
                  if (response?.data?.storeData?.id) {
                    commit("updateCurrentLocationUnservicable", true);

                    if (delType === "D") {
                      let { addressComponent = {} } =
                        response?.data?.storeData || {};
                      let userlocation = {
                        location: {
                          latitude:
                            payload2.coords.latitude ||
                            addressComponent?.latitude ||
                            "",
                          longitude:
                            payload2.coords.longitude ||
                            addressComponent?.longitude ||
                            "",
                        },
                      };
                      LocalStorageFunc.setLocalStorageValue(
                        "userLocationData",
                        JSON.stringify(userlocation)
                      );
                    }

                    if (LocalStorageFunc.isLocationSelectedFromPwaV2) {
                      LocalStorageFunc.unsetSessionStorageKey(
                        "lastLocationNewSource"
                      );
                    } else {
                      LocalStorageFunc.setLocationSelectedFromPwaV2();
                    }
                    if (
                      Utility.checkWindowLocationIncludes(
                        Utility.getCurrentStoreFolder() +
                          response.data.storeData.id
                      )
                    ) {
                      updateLocalLocationAfterStoreApi(
                        response.data.storeData,
                        commit,
                        payload
                      );
                      afterStoreApiSuccess(
                        response.data.storeData,
                        commit,
                        dispatch
                      );
                    }
                  } else {
                    storeNotFound(commit);
                  }
                })
                .catch(async function (error) {
                  if (delType === "D") {
                    LocalStorageFunc.setLocalStorageValue(
                      "userLocationData",
                      ""
                    );
                  }
                  storeNotFound(commit);
                });
            } else {
              dispatch("googleGeoLocationApi");
            }
          }
        })
        .catch((errors) => {
          if (delType === "D") {
            LocalStorageFunc.setLocalStorageValue("userLocationData", "");
          }
          return errors;
        });
    },

    loadRecentLocationFromLocalStorage({ commit, dispatch }, payload) {
      let recent = localStorage.lastLocationNew
        ? Utility.tryJsonParse(localStorage.lastLocationNew)[0]?.recent
        : {};

      let value = recent?.displayAddress || "";

      if (value) {
        commit("updateLocationFromLocalStorage", {
          isTrueLocationDetected:
            LocalStorageFunc.calculateIsTrueLocationDetectedFromLocationSource(),
          data: {
            address_alias: Utility.getAddressAlias(),
            complete_address:
              recent.homePageAddress?.bottomAddress ||
              recent.displayAddress ||
              "",
          },
        });
        commit("updateIsLocationSettled", {});
      } else {
        if (
          !Utility.checkWindowLocationIncludes(
            Utility.getCurrentStoreFolder() + Location.defaultStoreId
          )
        ) {
          // window.location.href =
          //   projectBasePathWithFolder +
          //   Utility.getCurrentStoreFolder() +
          //   Location.defaultStoreId +
          //   Utility.getUrlQueryString();
        }
        // commit("resetLocationState", {});
      }
    },
    autoCompleteApi({ commit, dispatch }, payload) {
      if (payload.input.length) {
        ApiCalls.LOCATOR_AUTOCOMPLETE_API({
          headers: Headers(),
          payload,
        })
          .then(function (response) {
            if (response.data.status === "SUCCESS") {
              commit("updateAutoCompleteData", {
                input: payload.input,
                predictions: response.data.predictions
                  ? response.data.predictions
                  : [],
              });
            }
          })
          .catch(function (err) {});
      }
    },
    locatorStoreTakeawayApi({ commit, state }, payload) {
      let value = LocalStorageFunc.getCoordsFromRecentLocation();
      let currentLocation = state.currentLocation;
      ApiCalls.LOCATOR_STORES_TAKEAWAY_API({
        headers: Headers(),
        payload: {
          // @Todo : uncomment below lines and remove hardcoded lines
          latitude:
            payload?.latitude || value?.coords?.latitude || currentLocation.lat,
          longitude:
            payload?.longitude ||
            value?.coords?.longitude ||
            currentLocation.lng,
          orderType: payload?.orderType || "P",
          // latitude: '28.5630315' ,
          // longitude: '77.3905778' ,
          // orderType: payload.orderType || "P",
        },
      })
        .then(function (response) {
          if (
            response?.data?.status == "SUCCESS" &&
            response?.data?.storeStationDetails.length > 0
          ) {
            commit(
              "updateTakeAwayStoresList",
              response.data.storeStationDetails
            );
            if (payload.setStoreByDefault) {
              LocalStorageFunc.setSelectedStore(
                response.data.storeStationDetails[0].store
              );
            }
          } else {
            commit("updateTakeAwayStoresList", []);
          }
        })
        .catch(function (error) {
          commit("updateTakeAwayStoresList", []);
        });
    },

    locatorStoreTakeawayDineInAvailabilityApi({ commit, dispatch }, payload) {
      ApiCalls.LOCATOR_STORES_TAKEAWAY_API({
        headers: Headers(),
        payload: {
          latitude: value?.coords?.latitude,
          longitude: value?.coords?.longitude,
          orderType: "P%2CCURB%2CDINEIN",
          extra: "distanceRequired=false",
        },
      })
        .then(function (response) {
          if (
            response?.data?.status == "SUCCESS" &&
            response?.data?.storeStationDetails.length > 0
          ) {
            let TAKEAWAY = false,
              DINEIN = false;
            response.data.storeStationDetails.map((storeStationDetail) => {
              storeStationDetail.store.stations.map((station) => {
                if (
                  station.status &&
                  station.operational &&
                  station.deliveryTypeCode == ORDER_TYPE.DINEIN
                ) {
                  DINEIN = true;
                }
                if (
                  station.status &&
                  station.operational &&
                  (station.deliveryTypeCode == ORDER_TYPE.PICKUP ||
                    station.deliveryTypeCode == ORDER_TYPE.CURB)
                ) {
                  TAKEAWAY = true;
                }
              });
            });
            commit("updateTakeawayDineAvailability", {
              TAKEAWAY: TAKEAWAY,
              DINEIN: DINEIN,
            });
          } else {
            commit("updateTakeawayDineAvailability", {});
          }
        })
        .catch(function (error) {
          commit("updateTakeawayDineAvailability", {});
        });
    },
  },
};
